export default class HistoryItem {
    constructor($el) {
        this.$el = $el;
        this.$content = this.$el.querySelector('[data-history-content]');
        this.$icon = this.$el.querySelector('[data-history-icon]');

        this.setActive = this.setActive.bind(this);
        this.removeActive = this.removeActive.bind(this);
        this.fitContentIcon = this.fitContentIcon.bind(this);

        this.fitContentIcon();
        this.$content.addEventListener('mouseenter', this.setActive);
        this.$content.addEventListener('mouseleave', this.removeActive);
        this.$icon.addEventListener('mouseenter', this.setActive);
        this.$icon.addEventListener('mouseleave', this.removeActive);
    }

    fitContentIcon() {
        const $svg = this.$el.querySelector('.history-item__content__icon svg');

        if (!$svg || $svg.getAttribute('viewBox')) {
            return;
        }

        let box;

        try {
            box = $svg.getBBox();
        }
        catch (e) {
            box = null;
        }

        if (!box || !box.width || !box.height) {
            const width = parseFloat($svg.getAttribute('width'));
            const height = parseFloat($svg.getAttribute('height'));

            if (!width || !height) {
                return;
            }

            box = {
                x: 0,
                y: 0,
                width,
                height,
            };
        }

        const padding = Math.max(box.width, box.height) * 0.04;
        const x = box.x - padding;
        const y = box.y - padding;
        const width = box.width + (padding * 2);
        const height = box.height + (padding * 2);

        $svg.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);
        $svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        $svg.removeAttribute('width');
        $svg.removeAttribute('height');
    }

    setActive() {
        this.$content.classList.add('history-item__content--background');
        this.$icon.classList.add('history-item__icon--background');
    }

    removeActive() {
        this.$content.classList.remove('history-item__content--background');
        this.$icon.classList.remove('history-item__icon--background');
    }
}
